// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__3_6tt","namePhoneContainer":"style_namePhoneContainer__1ijrR"};